module.exports = __webpack_public_path__ + "img/Aston_University2.1c94a31e.jpg";